import React, { Component } from "react";
import { Link } from "redux-little-router";
import OptimizedImg from "../../../components/OptimizedImg";
import { constructUserProfilePath, constructPostSlugPath } from "../../../util/index";

class Card extends Component {
  render() {
    let { owner, images, title } = this.props.post;
    const profilePath = constructUserProfilePath(owner);
    const imageUrl = this.props.post.coverPhotoUrl || images[0].url;

    return (
      <article className="card-wrapper">
        <Link className="-card-content" href={constructPostSlugPath(this.props.post)}>
          <OptimizedImg alt="Card Title" className="-card-img" url={imageUrl} size="m" />
          <h3 className="-card-title">{title}</h3>
        </Link>
        <span className="-card-footer">
          By:
          <a href={profilePath}>
            <span className="-user-name"> {owner.name}</span>
          </a>
        </span>
      </article>
    );
  }
}

export default Card;



// WEBPACK FOOTER //
// ./src/scenes/LandingPage/components/Card.js